import AddCourier from './couriers/AddCourier'
import CourierDetails from './couriers/CourierDetails'
import Couriers from './couriers/Couriers'
import CourierSettings from './couriers/CourierSettings'
import General from './general/General'
import OrderSources from './orderSources/OrderSources'
import OrderStatuses from './orderStatuses/OrderStatuses'
import OrderTags from './orderTags/OrderTags'
import ChangePlan from './planBilling/component/ChangePlan'
import PlanBilling from './planBilling/PlanBilling'
import ShipmentMethods from './shipmentMethods/ShipmentMethods'
import SMSSubecription from './SMSSubscription/SMSSubecription'
import StoreFront from './storeFront/StoreFront'
import AddStores from './stores/AddStores'
import StoreDetail from './stores/StoreDetail'
import StoresComponent from './stores/Stores'
import UserRoles from './userRoles/UserRoles'
import UserDetails from './users/UserDetails'
import Users from './users/Users'
import WhatsApp from './WhatsApp/WhatsApp'

export const ROUTES = [
  {
    component: General,
    isProtected: true,
    showMenu: true,
    path: '/admin',
    slug: 'admin',
    title: 'admin',

    redirectTo: '/auth/login',
  },
  {
    component: General,
    isProtected: true,
    showMenu: true,
    path: '/admin',
    slug: 'admin',
    title: 'admin',

    redirectTo: '/auth/login',
  },
  {
    component: Couriers,
    isProtected: true,
    showMenu: true,
    path: '/admin/couriers',
    slug: 'couriers',
    title: 'couriers',
    redirectTo: '/auth/login',
    isExact: true,
  },
  {
    component: AddCourier,
    isProtected: true,
    showMenu: true,
    path: '/admin/couriers/new',
    slug: 'couriers',
    title: 'couriers',
    isExact: true,

    redirectTo: '/auth/login',
  },
  {
    component: AddCourier,
    isProtected: true,
    showMenu: true,
    path: '/admin/couriers/new/:id',
    slug: 'courier Details',
    title: 'courier Details',
    isExact: true,

    redirectTo: '/auth/login',
  },
  {
    component: CourierSettings,
    isProtected: true,
    showMenu: true,
    path: '/admin/couriers/settings',
    slug: 'courier-settings',
    title: 'Courier Settings',
    isExact: true,

    redirectTo: '/auth/login',
  },
  {
    component: CourierDetails,
    isProtected: true,
    showMenu: true,
    path: '/admin/couriers/details/:id',
    slug: 'courier details',
    title: 'courier details',
    isExact: true,

    redirectTo: '/auth/login',
  },
  {
    component: StoresComponent,
    isProtected: true,
    showMenu: true,
    path: '/admin/stores',
    slug: 'stores',
    title: 'stores',
    isExact: true,
    redirectTo: '/auth/login',
  },
  {
    component: AddStores,
    isProtected: true,
    showMenu: true,
    path: '/admin/stores/new',
    slug: 'stores',
    title: 'stores',
    isExact: true,
    redirectTo: '/auth/login',
  },
  {
    component: StoreDetail,
    isProtected: true,
    showMenu: true,
    path: '/admin/store/:id',
    slug: 'stores',
    title: 'stores',
    isExact: true,
    redirectTo: '/auth/login',
  },
  {
    component: OrderStatuses,
    isProtected: true,
    showMenu: true,
    path: '/admin/order-statuses',
    slug: 'order-statuses',
    title: 'order-statuses',
    redirectTo: '/auth/login',
  },
  {
    component: OrderSources,
    isProtected: true,
    showMenu: true,
    path: '/admin/order-sources',
    slug: 'order-sources',
    title: 'order-sources',
    redirectTo: '/auth/login',
  },
  {
    component: OrderTags,
    isProtected: true,
    showMenu: true,
    path: '/admin/order-tags',
    slug: 'order-tags',
    title: 'order-tags',
    redirectTo: '/auth/login',
  },
  {
    component: ShipmentMethods,
    isProtected: true,
    showMenu: true,
    path: '/admin/shipment-methods',
    slug: 'shipment-methods',
    title: 'shipment-methods',
    redirectTo: '/auth/login',
  },

  {
    component: Users,
    isProtected: true,
    showMenu: true,
    path: '/admin/users',
    slug: 'users',
    title: 'users',
    redirectTo: '/auth/login',
    isExact: true,
  },
  {
    component: UserDetails,
    isProtected: true,
    showMenu: true,
    path: '/admin/users/:id',
    slug: 'users',
    title: 'users',
    redirectTo: '/auth/login',
    isExact: true,
  },
  {
    component: UserRoles,
    isProtected: true,
    showMenu: true,
    path: '/admin/user-roles',
    slug: 'user-roles',
    title: 'user-roles',
    redirectTo: '/auth/login',
  },
  {
    component: StoreFront,
    isProtected: true,
    showMenu: true,
    path: '/admin/storefront',
    slug: 'storefront',
    title: 'storefront',
    redirectTo: '/auth/login',
  },
  {
    component: PlanBilling,
    isProtected: true,
    showMenu: true,
    path: '/admin/subscription-plans',
    slug: 'subscription-plans',
    title: 'subscription-plans',
    isExact: true,
    redirectTo: '/auth/login',
  },
  {
    component: ChangePlan,
    isProtected: true,
    showMenu: true,
    path: '/admin/subscription-plans/change-plan',
    slug: 'subscription-plans',
    title: 'subscription-plans',
    isExact: true,
    redirectTo: '/auth/login',
  },
  {
    component: SMSSubecription,
    isProtected: true,
    showMenu: true,
    path: '/admin/sms',
    slug: 'sms',
    title: 'sms',
    redirectTo: '/auth/login',
  },
  {
    component: WhatsApp,
    isProtected: true,
    showMenu: true,
    path: '/admin/whatsapp',
    slug: 'whatsapp',
    title: 'whatsapp',
    redirectTo: '/auth/login',
  },
]
